import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { seedWebDemoSampleData } from './lib/demoSampleSeed';
import { initializeStorage } from './lib/storage';

async function bootstrap() {
  await initializeStorage();
  await seedWebDemoSampleData();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap().catch(error => {
  const root = document.getElementById('root');
  const message = error instanceof Error ? error.message : String(error);
  if (root) {
    root.textContent = '';
    const container = document.createElement('div');
    container.style.padding = '24px';
    container.style.fontFamily = 'sans-serif';
    container.style.color = '#991b1b';
    container.append('データ保存領域の初期化に失敗しました。');
    container.append(document.createElement('br'));
    container.append(`詳細: ${message}`);
    root.append(container);
  }
});
